import "./AiComponent.scss"
import {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import T from "../../../shared/component/t/T";
import Modal from "../../../shared/component/Modal/Modal";
import ComboBox from "../../../shared/component/ComboBox/ComboBox2";
import CheckBox from "../../../shared/component/CheckBox/CheckBox";
import {default as _} from "../../../helpers/Translate"
import TextBox from "../../../shared/component/textbox/Textbox";
import Button from "../../../shared/component/button/Button";
import AiComponent_Image from "./AiComponent_Image";
import {ConfigProvider, Skeleton, theme} from "antd"
import Ai from "../../../core/api/ai/Ai";
import {_loading} from "../../../actions/Loading";
import {_alert} from "../../../actions/Alert";
import {Viewer} from "@toast-ui/react-editor";
import snippets from "../../../helpers/snippets";

const MAX_ALLOWED_PIC = 3
const ai = new Ai()

const AiComponent = ({
	                     showModal = false,
	                     closeModal = () => {},
	                     imgs = [],
	                     NewStudyReport = {}
                     }) => {
	const dispatch = useDispatch()
	const language = useSelector((state) => state.LangReducer.language);
	const [aiModels, setAiModels] = useState({
		selected: {id: -1}, options: []
	})
	const [withReport, setWithReport] = useState({
		state: false, text: ''
	})
	const [question, setQuestion] = useState([{
		text: '',
		state: 0,       // 0 is for initial | 1 is waiting for response | 2 is server respond
		job_id: -1,
		respond: []
	}])
	const [images, setImages] = useState({
		img: imgs,
		selected: []
	})
	const [loading, setLoading] = useState({
		state: false,
		job_id: 0,
		credit: 0
	})
	
	
	useEffect(() => {
		dispatch(_loading(true))
		const initOption = {id: 0, text: 'choose_one', value: 0}
		let options = []
		ai.list(NewStudyReport.study_id).then((response) => {
			options = response.data.models?.map((item) => ({
				id: item.id, text: item.name, value: item.id, prompt: item.prompt, cost: item.cost
			}))
			setLoading(prevState => ({...prevState, credit: response.data.remain_credit}))
		}).catch((error) => {
			console.error(error)
			closeModal()
		}).finally(() => {
			dispatch(_loading(false))
			setAiModels({
				selected: initOption,
				options: [initOption, ...options]
			})
		})
	}, []);
	
	
	useEffect(() => {
		let intervalId;
		if (loading.state) {
			intervalId = setInterval(() => {
				checkState(loading.job_id)
			}, 1000)
		}
		return () => {
			if (intervalId) clearInterval(intervalId);
		};
	}, [loading.state])
	
	const loadingFinished = () => {
		setLoading(prevState => ({...prevState, state: false, job_id: 0}))
	}
	
	const checkState = (job_id) => {
		ai.check(job_id).then((response) => {
			let status = response.data.status
			if (status === 'completed') {
				getRespond(response.data.responses)
			} else if (status === "failed") {
				dispatch(_alert(true, 'error', response.data.message))
				getRespond([response.data.message])
			}
		}).catch(() => {
			loadingFinished()
		})
	}
	
	const getRespond = (responses) => {
		changeQuestion({respond: responses, state: 2})
		loadingFinished()
	}
	
	const changeQuestion = (data = {}, index = null) => {
		let ques = question
		if (!index) {
			index = ques.length - 1
		}
		ques[index] = {...ques[index], ...data}
		setQuestion([...ques])
	}
	
	const aiModelChange = (value) => {
		const item = aiModels.options?.find(it => it.id?.toString() === value)
		setAiModels(prevState => ({...prevState, selected: item}))
		
		let lastQues = question[question.length - 1]
		let exists = lastQues.text.includes(item.prompt)
		if (item.id && !exists) {
			changeQuestion({'text': item.prompt + '\n' + lastQues.text})
		}
	}
	
	const withReportCheckbox = (e) => {
		setWithReport(prevState => ({...prevState, state: e.checked}))
	}
	
	const questionChange = (index, value) => {
		let tmp = question
		tmp[index] = {...tmp[index], text: value}
		setQuestion([...tmp])
	}
	
	const footer = () => {
		return <>
			<div className={'imodal__action'}>
				<div className={'imodal__btn imodal__btn--secondary'}
				     onClick={closeModal}><T token={'close'} lang={language}/>
				</div>
			</div>
		</>
	}
	
	const sendQuestion = (item) => {
		let obj = {
			"ai_model_id": aiModels.selected.id,
			"study_id": NewStudyReport.study_id,
			// "report_id": null,
			"file_ids": images.selected.map(it => it.imgSeriesFileID),
			"prompt_text": withReport.state
				? `${NewStudyReport.findings} \n ${item.text}`
				: `${item.text}`
		}
		ai.create(obj).then(response => {
			const job_id = response.data.request_id
			changeQuestion({state: 1, job_id: job_id})
			setLoading(prevState => ({...prevState, state: true, job_id: job_id}))
		})
	}
	
	const updateImages = (newValues) => {
		setImages(prevState => ({...prevState, selected: [...newValues]}))
	}
	
	const respondHandler = (item) => {
		if (item.state === 1) {
			return <ConfigProvider theme={{algorithm: theme.darkAlgorithm}}>
				<Skeleton.Input style={{width: '66dvw', height: '65px'}} active/>
			</ConfigProvider>
		} else if (item.state > 1) {
			let text = item.respond[item.respond.length - 1].text
			return <div className={'viewer'}>
				<Viewer
					key={snippets.randomKey()}
					initialValue={text}
					height='95%'
					width='95%'
				/>
			</div>
		}
	}
	
	const editorOrViewer = (item, index) => {
		if (item.state < 1) {
			return <TextBox changeValue={(e) => questionChange(index, e.target.value)}
			                placeholder={_.init('ask_ai_question_placeholder')}
			                value={item.text}
			                type="textarea"
			                disable={item.state}
			                style={{whiteSpace: 'pre-wrap'}}
			                textConfigs={{rows: 8}}
			/>
		} else {
			return <div className={'viewer'}><Viewer
				key={item.text}
				initialValue={item.text}
				height='95%'
				width='95%'
			/>
			</div>
		}
	}
	
	const questionsDIV = () => {
		return question.map((item, index) => (<>
			<div className={'col-12 d-flex justify-content-between align-items-center'} key={index}>
				<span className={`col ${item.state < 1 ? 'col-10' : 'col-6'} `}>
					{editorOrViewer(item, index)}
				</span>
				<span className={'col-2 d-flex justify-content-center'}>
					{item.state < 1 ?
						<Button className={`sign__action sign__action--primary ${item.state ? "disabled" : ""}`}
						        onClick={() => sendQuestion(item)}
						>
							<T token={'send'}/>
						</Button>
						:
						<></>
					}
				</span>
			</div>
			
			<div className={'col-12'}>
				{respondHandler(item)}
			</div>
		</>))
	}
	
	const aiModelInfo = () => {
		if (aiModels.selected.id <= 0) return
		return snippets.description('', _.init4('each_question_price',
			{price: `${snippets.commaSeperator(aiModels.selected.cost)} ${_.init('toman')}`})
		)
	}
	
	const body = () => {
		return <>
			<div className={'imodal__body row row-gap-2 fw-normal'}>
				<div className={'row'}>
					<div className={'col-8'}>
						<ComboBox className={``}
						          type="select"
						          labelText={"choose_ai_model"}
						          selectedItem={aiModels.selected.id}
						          comboboxValues={aiModels.options}
						          changeValueHandler={aiModelChange}
						          show
						/>
						<span>
							{aiModelInfo()}
						</span>
					</div>
					<div className={'col-4 d-flex align-items-center justify-content-end'}>
						<span className={'opacity-75 mx-1'}>
							<T token={'remain_credit'} /> :
						</span>
						<span className={''}>
							{snippets.commaSeperator(loading.credit, language)}
							<span className={'opacity-75 mx-1'}>
								<T token={'toman'}/>
							</span>
						</span>
					</div>
				</div>
				
				{images.img.length ? <div className={'row row-gap-4 px-4 align-items-center'}>
					<T token={'choose_pictures'}/>:
					<AiComponent_Image img={images}
					                   maxSize={MAX_ALLOWED_PIC}
					                   update={updateImages}/>
				</div>
				: <></>}
				
				<div className={'col-12'}>
					<CheckBox type="complex"
					          disableMainLabel={true}
					          name="withReport"
					          value={1}
					          labelText={"send_report_ai"}
					          handleChangeValue={withReportCheckbox}
					          checked={withReport.state}
					          icon={"fal fa-info-circle"}
					          tooltipWithIcon={_.init("send_report_ai_hint")}
					          transparent
					/>
				</div>
				
				{questionsDIV()}
			
			</div>
		</>
	}
	
	return <>
		{showModal && <Modal className="spell_check_modal"
		                     title="ask_ai_title"
		                     closeModal={closeModal}
		                     footer={footer()}
		>
			<div className={'imodal spell_check'}>
				<div className={'imodal__body spell_check_body'}>
					{body()}
				</div>
			</div>
		</Modal>}
	</>
}

export default AiComponent;